import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import { Card, CardImg, CardBody, CardTitle, CardText } from "reactstrap";
import { Link } from "react-router-dom";
import * as actions from "../actions";
import { IMAGE_URL } from "../actions/types";
import NavigationLeft from "./NavigationLeft";

class Subcategory extends Component {
  state = {
    main: "",
    sub: "",
  };

  componentDidMount() {
    const url = this.props.location.pathname.split("/").filter((elem) => {
      return elem !== "";
    });
    this.setState({ main: url[0], sub: url[1] });
    this.props.getCategory({ main: url[0], sub: url[1] });
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.location.pathname === this.props.location.pathname) {
      return null;
    }

    const url = nextprops.location.pathname.split("/").filter((elem) => {
      return elem !== "";
    });
    this.setState({ main: url[0], sub: url[1] });
    this.props.getCategory({ main: url[0], sub: url[1] });
  }

  compare(a, b) {
    return a.name.localeCompare(b.name);
  }

  renderProducts() {
    if (!this.props.categories.category_description.products.length) {
      return (
        <Row>
          <Col>Ei tuotteita</Col>
        </Row>
      );
    }

    const sortedProducts = this.props.categories.category_description.products;
    sortedProducts.sort(this.compare);

    return (
      <div>
        <h2>Tuotteet</h2>
        <Row>
          {this.props.categories.category_description.products.map((p) => {
            //  const link = `/${this.state.main}/${p}`;
            const image = p.images.length ? `${IMAGE_URL}/360/${p.images[0]}` : "";
            //            const link = `./${this.props.match.params.subCat}/${p.name}`;
            const link = `/${p.ParentCategory}/${p.SubCategory}/${p.name}`;
            return (
              <Col sm="12" md="6" lg="4" key={`${p.name}${p.date}`} style={{ marginBottom: "20px" }}>
                <Link to={link}>
                  <Card>
                    <CardImg top width="100%" src={image} alt={p.name} />
                    <CardBody>
                      <CardTitle className="subCardTitle">{decodeURIComponent(p.name)}</CardTitle>
                      <CardText>
                        <b>{p.price}€</b>
                      </CardText>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }

  render() {
    if (!this.props.categories.categories_descriptions[this.state.main]) {
      return <div />;
    }

    const desc = {
      __html: this.props.categories.category_description.description,
    };
    return (
      <div>
        <Container fluid>
          <Row style={{ textAlign: "center" }}>
            <Col xs="12">
              <NavigationLeft
                page={this.state.main}
                categories={this.props.categories.categories_menu[this.state.main].categories}
                numberOfProducts={
                  this.props.categories.categories_menu[this.state.main].numberOfProducts
                }
                selected={this.state.sub}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col xs="12" className="CategoryMainDesctiption">
              <h3 className="navigationLink">
                <Link to={`/${this.state.main}`}>{this.state.main}</Link>
              </h3>
              <h1>{this.props.match.params.subCat}</h1>
              <div dangerouslySetInnerHTML={desc} />
              <Row />
              <hr />
              {this.renderProducts()}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps({ categories }) {
  return { categories };
}

export default connect(mapStateToProps, actions)(Subcategory);
